<template>


  <div class="container container-tabs">

    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

      <el-tab-pane name="all" class="to-searh">
        <span slot="label" class="table-title">全部</span>
      </el-tab-pane>

      <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
        <span slot="label" class="table-title">{{ item.alias }}</span>
      </el-tab-pane>







      <div>

        <el-button type="primary" icon="el-icon-search" @click="searchDriverPromoteConfLists">搜索</el-button>
        <el-button @click="add_isShow=!add_isShow">添加</el-button>
        <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

      </div>

    </el-tabs>


    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
    @selection-change="handleSelectionChange">

      <el-table-column type="selection" width="55" align="center" prop="driver_promote_conf_code"></el-table-column>

      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <div class="more-style">

              <el-form-item :label="props.row.synchronization.activity_point.name+':'">
                <span>{{ props.row.synchronization.activity_point.amount }}</span>
              </el-form-item>

              <el-form-item :label="props.row.synchronization.priority_coupon.name+':'">
                <span>{{ props.row.synchronization.priority_coupon.amount }}</span>
              </el-form-item>

              <el-form-item :label="props.row.synchronization.priority_point.name+':'">
                <span>{{ props.row.synchronization.priority_point.amount }}</span>
              </el-form-item>

            </div>
          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" min-width="80">
      </el-table-column>
      <el-table-column prop="title" label="标题" min-width="150">
      </el-table-column>
      <el-table-column prop="city.name" label="所属城市" min-width="150">
      </el-table-column>
      <el-table-column prop="award_count" label="总奖励次数" min-width="80">
      </el-table-column>
      <el-table-column prop="start_time.YmdHis" label="开始时间" min-width="150">
      </el-table-column>
      <el-table-column prop="end_time.YmdHis" label="结束时间" min-width="150">
      </el-table-column>
      <el-table-column label="使用状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
            {{scope.row.status.alias}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="time.Ymd" label="	创建时间" min-width="150">
      </el-table-column>







      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-button type="primary"
            @click="edit_isShow = !edit_isShow; driverPromote_children = scope.row.driver_promote_conf_code; ">

            编辑


          </el-button>

        </template>
      </el-table-column>



    </el-table>
    <!-- 批量删除按钮 -->
    <el-button type="primary" icon="el-icon-delete" class="handle-del mr10" @click="deleteData"
      style="margin-top: 20px;">批量删除</el-button>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <!-- 添加组件 -->
    <addDriverPromote :isShow="add_isShow" @onSubmit="driverPromoteConfLists"></addDriverPromote>

    <!-- 编辑组件 -->
    <editDriverPromote :isShow="edit_isShow" :data="driverPromote_children" @onSubmit="driverPromoteConfLists">
    </editDriverPromote>


  </div>


</template>

<script>
  var _this;
  import addDriverPromote from './addDriverPromote.vue';
  import editDriverPromote from './editDriverPromote.vue';


  export default {
    components: {

      addDriverPromote,
      editDriverPromote,

    },
    data() {
      return {


        // 选项卡默认选中项
        activeName: 'all',

        // 传入子组件的数据
        driverPromote_children: '',



        // 抽屉开关按钮
        edit_isShow: false,
        add_isShow: false,

        // 批量删除
        delAdvertSubmit_data: {
          driver_promote_conf_code_array: []
        },
        delAdvertSubmit_rules: {
          driver_promote_conf_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },


        // 下拉搜索管理状态
        value_status_code: '',
        value_status_array: [],

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          title: '',
          status: '',
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },
      };
    },
    created() {
      _this = this;
      _this.driverPromoteConfLists();
    },

    methods: {
      searchDriverPromoteConfLists(){
        _this.search_data.page = 1;
        _this.driverPromoteConfLists();
      },





      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].driver_promote_conf_code);

        }
        _this.delAdvertSubmit_data.driver_promote_conf_code_array = datalist;


      },

      // 批量删除
      deleteData() {
        console.log(_this.delAdvertSubmit_data);

        if (_this.delAdvertSubmit_data.driver_promote_conf_code_array.length == 0) {

          _this.$message.warning('请至少勾选一条数据');

          return;
        }


        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {
          _this.delAdvertSubmit_data.driver_promote_conf_code_array = JSON.stringify(_this.delAdvertSubmit_data
            .driver_promote_conf_code_array);

          _this.$post(
              "/promote/delDriverPromoteConfSubmit",
              _this.delAdvertSubmit_data,
              _this.delAdvertSubmit_rules
            )
            .then(res => {

              _this.$message.success('删除成功!');

              //初始化显示列表
              _this.driverPromoteConfLists();

            }).catch((err) => {

            })

        }).catch(() => {

          _this.$message.info('已取消删除');

        });

      },


      // 选项卡选中事件
      handleClick(tab, event) {
        // 点击的选项卡所对应的val值
        console.log(tab.name);
        if (tab.name != 'all') {
          _this.search_data.status = tab.name;
        } else {
          _this.search_data.status = '';
        }
        _this.search_data.page = 1;
        _this.driverPromoteConfLists();

      },

      // 搜索司机列表
      driverPromoteConfLists() {
        _this.$post(
            "/promote/driverPromoteConfLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

            _this.value_status_array = _this.tableData[0].status.select_array;

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.driverPromoteConfLists();

      },

      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    max-width: 150px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>